import fetch from '../core/fetch';

export const verifyRecaptcha = async ({ values, reCaptcha }) => {

    let token, secretKey;
    if (reCaptcha?.reCaptchaStatus == 'v3') {
        token = await window.grecaptcha.execute(reCaptcha?.v3Sitekey, { action: 'ContactForm' });
        secretKey = reCaptcha?.reCaptchaV3;
    } else {
        token = values?.reCaptcha,
            secretKey = reCaptcha?.reCaptchaV2
    }

    const response = await fetch('/verify-recaptcha', {
        method: 'POST',
        body: JSON.stringify({ token: token, secretKey: secretKey }),
        headers: { 'Content-Type': 'application/json' },
    });
    const data = await response.json();

    return data;

}